import { render, staticRenderFns } from "./DoctorsTable_dialog.vue?vue&type=template&id=ab990454"
import script from "./DoctorsTable_dialog.vue?vue&type=script&lang=js"
export * from "./DoctorsTable_dialog.vue?vue&type=script&lang=js"
import style0 from "./DoctorsTable_dialog.vue?vue&type=style&index=0&id=ab990454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports